export const assuranceFr = {
  "Societé": "Societé",
  "Consultation": "Consultation",
  "Couleur": "Couleur",
  "Type": "Type",
  "Afficher les Archives": "Afficher les Archives",
  "Facture Global": "Facture Globale",

  // Server side 

  "La societe existe deja!": "La societe existe deja!",
  "le nom de la societe est obligatoire!": "le nom de la societe est obligatoire!",
  "Prix de la consultation est obligatoire!": "Prix de la consultation est obligatoire!",
  "Impossible de supprimer la facture": "Impossible de supprimer la facture",
  

}